import { CONSENT_STORAGE_KEY, CONSENT_STORAGE_VERSION, defaultConsentPreferences } from "./config";
import { ConsentPreferences, StoredConsentDecision } from "./types";

const randomId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `consent-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const createConsentDecision = (preferences: ConsentPreferences): StoredConsentDecision => ({
  version: CONSENT_STORAGE_VERSION,
  consentId: randomId(),
  decidedAt: new Date().toISOString(),
  preferences: {
    ...defaultConsentPreferences,
    ...preferences,
    essential: true,
  },
});

export const loadStoredConsentDecision = (): StoredConsentDecision | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as StoredConsentDecision;
    if (parsed?.version !== CONSENT_STORAGE_VERSION || !parsed.preferences) {
      return null;
    }

    return {
      ...parsed,
      preferences: {
        ...defaultConsentPreferences,
        ...parsed.preferences,
        essential: true,
      },
    };
  } catch {
    return null;
  }
};

export const saveStoredConsentDecision = (decision: StoredConsentDecision) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(decision));
};

export const clearStoredConsentDecision = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(CONSENT_STORAGE_KEY);
};
